
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import Icon, { icons } from "../shared/components/Icon.js";
import "../shared/css/index.css"
import { Playground, PropsTable } from "docz";

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>

<MDXTag name="h1" components={components} props={{"id":"icon"}}>{`Icon`}</MDXTag>
<Playground __position={0} __code={'<div>\n  {Object.keys(icons).map(iconShape => (\n    <Icon shape={iconShape} />\n  ))}\n</div>'} __scope={{props: this ? this.props : props,Icon,icons}}>
  <div>
    { Object.keys(icons).map((iconShape) => <Icon shape={iconShape} />) }
  </div>
</Playground>
<PropsTable of={Icon} />
<MDXTag name="h2" components={components} props={{"id":"colored-icons"}}>{`Colored icons`}</MDXTag>
<Playground __position={2} __code={'<Icon shape={\'user\'} style={{ fill: \'var(--blue)\' }} />'} __scope={{props: this ? this.props : props,Icon,icons}}>
  <Icon shape={"user"} style={{ fill: "var(--blue)" }}/>
</Playground>
           </MDXTag>
  }
}
  